import React from "react";
import { Helmet } from "react-helmet";
import HeaderTitle from "../../../components/header/headerTitle/headerTitle";
import Image from "../../../components/image";
import { asset } from "../../../helpers/dom.helper";
import "./style.scss";
import { ECOMERCE_ASSISTANT } from './eCommerceAssistantJson'
import { Link } from "react-router-dom";
import { toRoute } from "../../../i18n";
import { Media, MediaContextProvider } from "../../../media";


function ECommerceAssistant(props) {

  return (
    <>
      <Helmet>
        <title>Custom Luxury E-Commerce Packaging Solutions | Lussopack</title>
        <meta name="description" content="Lussopack provides luxury packaging solutions to help online businesses transfer products safely, ensuring an ultimate unboxing experience." />
        <meta name="keywords" content="e commerce packaging solutions"/>
        <link rel="canonical" href="https://lussopack.com/packaging/" />  
      </Helmet>

      {/* <ScrollToTopOnMount /> */}
      <HeaderTitle
        {...props}
        textHeader={"E-Commerce Assistant"}
        isShowOurReference={true}
      />
      <MediaContextProvider>
        <Media greaterThanOrEqual="md">
          <div id="eCommerceAssistant">
              <h2 className="text-center">E-Commerce Assistant</h2>
              <div>
              <div className="eCommerceAssistantList">
                <div className={`eCommerceAssistantItem`}>
                    <Link to={toRoute(ECOMERCE_ASSISTANT.path)}>
                    <Image
                      src={asset(`${ECOMERCE_ASSISTANT.itemImageDesktop}`)}
                      alt={`${ECOMERCE_ASSISTANT.item}`}
                      className="img-fluid zoom"
                      width="345"
                      height="345"
                    />
                    </Link>
                    <Link to={toRoute(ECOMERCE_ASSISTANT.path)}>
                      <p className="text-center mt-2">{ECOMERCE_ASSISTANT.item}</p>
                    </Link>
                  </div>
              </div>
              </div>
              <div className="descriptionConatainer">
                <p>At our core, we are a dedicated packaging company committed to revolutionizing the way online businesses and e-commerce ventures present and protect their products. We understand the critical role packaging plays in the modern marketplace, where the first impression can make all the difference. With this in mind, we specialize in crafting packaging solutions that not only ensure the safe transit of items but also elevate the unboxing experience.</p>
                <p>We are ready to be the trusted partner that online businesses rely on to deliver their products securely and with a touch of elegance. Our mission is clear: to help businesses thrive by providing them with packaging solutions that reflect their dedication to quality and customer satisfaction.</p>
                
                <h3><b>Key Benefits for Clients</b></h3>
                <div className="listConatainer">
                  <ul>
                    <li>Efficiency and Convenience : By offering a range of packaging solutions, we provide a one-stop-shop for businesses. This saves our customers time and effort in sourcing different types of packaging materials from various suppliers.</li>
                    <li>Professionalism and Branding : Our packaging solutions can help businesses maintain a consistent and professional image in the eyes of their customers. This is crucial for building trust and loyalty.</li>
                    <li>Cost-effectiveness : Through our expertise, we can help businesses select the most cost-effective packaging solutions that still meet their safety and aesthetic requirements. This can potentially lead to cost savings in the long run.</li>        
                  </ul>
                </div>

                <h3><b>Why us?</b></h3>
                <div className="listConatainer">
                  <ul>
                      <li>We specializes in crafting packaging solutions tailored specifically for online businesses. This specialization means that we understand the unique needs and challenges that e-commerce ventures face. </li>
                      <li>We use high-grade materials and employ precision manufacturing techniques to ensure that our packaging is durable, reliable, and aesthetically pleasing.</li>
                      <li>We offer a wide range of customization options. Whether it's selecting the right size, shape, or design elements, we provide the flexibility for businesses to create packaging that aligns perfectly with their brand identity.</li>
                      <li>We understand the importance of eco-conscious practices in today's world, and our packaging materials are chosen with this in mind.</li>
                  </ul>
                </div>
              </div>
          </div>
        </Media>
        <Media lessThan="md">
          <div id="eCommerceAssistantMobile">
              <h2>E-Commerce Assistant</h2>
              <div>
              <div className="eCommerceAssistantList">
                <div className={`eCommerceAssistantItem`}>
                    <Link to={toRoute(ECOMERCE_ASSISTANT.path)}>
                    <Image
                      src={asset(`${ECOMERCE_ASSISTANT.itemImageDesktop}`)}
                      alt={`${ECOMERCE_ASSISTANT.item}`}
                      className="img-fluid"
                      width="345"
                      height="345"
                    />
                    <p>{ECOMERCE_ASSISTANT.item}</p>
                    </Link>
                  </div>
              </div>
              </div>

                <p>At our core, we are a dedicated packaging company committed to revolutionizing the way online businesses and e-commerce ventures present and protect their products. We understand the critical role packaging plays in the modern marketplace, where the first impression can make all the difference. With this in mind, we specialize in crafting packaging solutions that not only ensure the safe transit of items but also elevate the unboxing experience.</p>
                <p>We are ready to be the trusted partner that online businesses rely on to deliver their products securely and with a touch of elegance. Our mission is clear: to help businesses thrive by providing them with packaging solutions that reflect their dedication to quality and customer satisfaction.</p>
                
                <h3><b>Key Benefits for Clients</b></h3>
                  <ul>
                    <li>Efficiency and Convenience: By offering a range of packaging solutions, we provide a one-stop-shop for businesses. This saves our customers time and effort in sourcing different types of packaging materials from various suppliers.</li>
                    <li>Professionalism and Branding: Our packaging solutions can help businesses maintain a consistent and professional image in the eyes of their customers. This is crucial for building trust and loyalty.</li>
                    <li>Cost-effectiveness: Through our expertise, we can help businesses select the most cost-effective packaging solutions that still meet their safety and aesthetic requirements. This can potentially lead to cost savings in the long run.</li>        
                  </ul>

                <h3><b>Why us?</b></h3>
                  <ul>
                      <li>We specializes in crafting packaging solutions tailored specifically for online businesses. This specialization means that we understand the unique needs and challenges that e-commerce ventures face. </li>
                      <li>We use high-grade materials and employ precision manufacturing techniques to ensure that our packaging is durable, reliable, and aesthetically pleasing.</li>
                      <li>We offer a wide range of customization options. Whether it's selecting the right size, shape, or design elements, we provide the flexibility for businesses to create packaging that aligns perfectly with their brand identity.</li>
                      <li>We understand the importance of eco-conscious practices in today's world, and our packaging materials are chosen with this in mind.</li>
                  </ul>
          </div>
        </Media>
      </MediaContextProvider>
    </>
  );
}

export default ECommerceAssistant;
